export default __webpack_public_path__ + "static/media/homewavebtm.be0dcd35.png";